import React, {useContext, useEffect, useState} from 'react';

import Modalheader from "components/modal/components/header";
import ModalBody from "components/modal/components/body";
import ModalFooter from "components/modal/components/footer";
import Button from "components/button";
import {Calendar, Localisation} from "assets/icons";
import DatePicker from "react-datepicker";
import ApiDatabase from 'server'
import {toast} from "react-toastify";
import usefetchdata from "hooks/usefetchdata";
import useModal from "components/modal/useModal";
import UseContext from "hooks/useContext";


const Modalexperiencemodify = () => {
    const {refreshLoadWorker, expID} = UseContext()
    const {toggle} = useModal()
    const {tempWorkerData} = usefetchdata()
    const [experience, setExperience] = useState({
        metier: '',
        entreprise: '',
        localisation: '',
        dateStart: '',
        dateEnd: ''
    })
    useEffect(() => {
        const exp = tempWorkerData?.experiences?.find(item => item._id === expID)
        if (exp) {
            setExperience({
                metier: exp.name,
                entreprise: exp.company?.name,
                localisation: exp.company?.location,
                dateStart: new Date(exp.date.start),
                dateEnd: exp.date.end ? new Date(exp.date.end):''
            })
            exp.date.end ==='' || exp.date.end === null ? setCheck(true) : setCheck(false) 
            console.log(check);
        }
    }, [tempWorkerData?.experiences])
    const [error, setError] = useState(false)
    const [check, setCheck] = useState(false)
    useEffect(() => {
        if (experience.dateStart > experience.dateEnd && experience.dateEnd !== '') setError(true)
        else setError(false)
    }, [experience.dateStart, experience.dateEnd])

    const handleChange = e => {
        e.preventDefault()
        const type = e.type.target
        const name = e.target.name

        const value = type === 'checkbox'
            ? e.target.checked
            : e.target.value

        setExperience(prevData => ({
            ...prevData,
            [name]: value
        }))
    }
    const handleSubmit = e => {
        if (!error) {
            ApiDatabase.putUpdateExp({
                    token: localStorage.getItem('xsrfToken'),
                    expID,
                    experience
                },
                (data) => {
                    if (data.success) {
                        refreshLoadWorker()
                        toggle()
                        toast.success(`Votre expérience ${experience.metier} est modifiée`)
                    }
                },
                (err) => {
                    toast.error('une erreur est survenu')

                })
        }
    }

    return (
        <>
            <Modalheader hide={toggle} hideShow={true}>Modifier une expérience</Modalheader>
            <ModalBody>
                <form className='grid grid-cols-2 gap-2'>
                    <div className="col-span-2">
                        <label
                            htmlFor="metier"
                            className="block ft-sm font-medium  text-gray-500"
                        >
                            Métier
                        </label>
                        <div className=" text-gray-500">
                            <input
                                name="metier"
                                pattern="([A-Z])[\w+.]{1,}"
                                value={experience.metier}
                                onChange={handleChange}
                                className="w-full h-10 pl-2 pr-3 ft-b placeholder-gray-600 border rounded-lg "
                                type="text"
                                required
                            />
                        </div>
                    </div>
                    <div className="col-span-2">
                        <label
                            htmlFor="entreprise"
                            className="block ft-sm font-medium  text-gray-500"
                        >
                            Nom de l'entreprise
                        </label>
                        <div className="text-gray-500">
                            <input
                                name="entreprise"
                                value={experience.entreprise}
                                onChange={handleChange}
                                className="w-full h-10 pl-2 pr-3 ft-b placeholder-gray-600 border rounded-lg "
                                type="text"
                                pattern="([A-Z])[\w+.]{1,}"
                                required
                            />
                        </div>
                    </div>
                    <div className="col-span-2">
                        <label
                            htmlFor="localisation"
                            className="block ft-sm font-medium  text-gray-500"
                        >
                            Lieu de travail
                        </label>
                        <div className="relative text-gray-500">
                            <input
                                name="localisation"
                                value={experience.localisation}
                                onChange={handleChange}
                                className="w-full h-10 pl-8 pr-3 ft-b placeholder-gray-600 border rounded-lg "
                                type="text"
                                required
                            />

                            <div
                                className="absolute inset-y-0 left-0 flex items-center px-2 pointer-events-none">
                                <Localisation wh={18} color={'#666666'}
                                              strokeW={2}/>
                            </div>
                        </div>
                    </div>
                    <div className="col-span-1">
                        <label
                            htmlFor="dateStart"
                            className="block ft-sm font-medium  text-gray-500"
                        >
                            Date de début
                        </label>
                        <div className='relative'>
                            <DatePicker
                                dateFormat="dd/MM/yyyy"
                                selected={experience.dateStart}
                                onChange={(date) => setExperience({
                                    ...experience,
                                    dateStart: date
                                })}
                                peekNextMonth disabledKeyboardNavigation
                                showMonthDropdown
                                showYearDropdown
                                dropdownMode="select"
                                popperPlacement="bottom"
                                className='w-full h-10 pl-3 pr-8 ft-b border rounded-lg pl-8 cursor-pointer'
                            />
                            <div
                                className="absolute inset-y-0 left-0 flex items-center px-2 pointer-events-none">
                                <Calendar wh={18} color={'#666666'}
                                          strokeW={2}/>
                            </div>
                        </div>
                    </div>
                    {check ? '' :
                        <div className="col-span-1">
                            <label
                                htmlFor="dateEnd"
                                className="block ft-sm font-medium  text-gray-500"
                            >
                                Date de Fin
                            </label>
                            <div className='relative'>
                                <DatePicker
                                    dateFormat="dd/MM/yyyy"
                                    selected={experience.dateEnd}
                                    onChange={(date) => setExperience({
                                        ...experience,
                                        dateEnd: date
                                    })}
                                    peekNextMonth disabledKeyboardNavigation
                                    showMonthDropdown
                                    showYearDropdown
                                    dropdownMode="select"
                                    popperPlacement="bottom"
                                    className='w-full h-10 pl-3 pr-8 ft-b border rounded-lg pl-8 cursor-pointer'
                                />
                                <div
                                    className="absolute inset-y-0 left-0 flex items-center px-2 pointer-events-none">
                                    <Calendar wh={18} color={'#666666'}
                                              strokeW={2}/>
                                </div>
                            </div>
                            {error ?
                                <span className='ft-sm text-red-500'>Veuillez indiquer une date valide</span> : ''}
                        </div>
                    }
                    <div className='col-span-2 flex gap-2'>
                        <input name='check' type="checkbox"
                        checked={check}
                               onChange={() => setCheck(!check)}/>
                        <label className='ft-sm text-gray-700' htmlFor="check">J’occupe
                            actuellement ce poste</label>
                    </div>
                </form>
            </ModalBody>
            <ModalFooter>
                <Button size={'LG'} color={'SECONDARY'}
                        onClick={toggle}>Annuler</Button>
                <Button size={'LG'} onClick={handleSubmit}>Confirmer</Button>
            </ModalFooter>

        </>
    );
};

export default Modalexperiencemodify;